import { Page } from "@rentiohq/web-shared/dist/components";
import * as t from "../../services/translationService";

export const NotFound = () => <Page title={t.pageNotFoundTitle()} />;
